import permissions from "app/permissions";
import ListSentEmails from "./List";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import { NotificationServicePath, SENT_EMAILS } from "utils/constants";

export const resources = {
  isMenu: true,
  icon: <MarkEmailReadIcon />,
  name: NotificationServicePath + SENT_EMAILS,
  title: "Изпратени имейли",
  list: <ListSentEmails />,
  permission: permissions.canPreviewSentEmailsHistory,
};
